import { Group } from 'src/design/atoms/Group';
import { Tabs } from 'src/design/molecules/Tabs';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MeetingListDto } from 'src/api/FiretrolApiClient';
import { useMeetings } from 'src/api/queries/meetings/useMeetings';
import { useJobs } from 'src/hooks/useJobs';
import { CreateButton } from 'src/design/atoms/CreateButton';
import { Header } from 'src/design/organisms/Header';
import { IssuesTable } from './components/IssuesTable';
import { MeetingTable } from './components/MeetingsTable';

export const MeetingMinutes: React.FC = () => {
  const { selectedJob } = useJobs();
  const navigate = useNavigate();
  const { data: meetings = [], isLoading: loading } = useMeetings(
    selectedJob?.id,
  );

  const onMeetingClicked = (meeting: MeetingListDto) => {
    navigate(`/jobs/${meeting.jobId}/meetings/edit/${meeting.id}`);
  };

  if (!selectedJob) return null;

  return (
    <>
      <Header
        title="Meeting Minutes"
        breadcrumbProps={{
          items: [
            { text: 'Jobs', href: '/jobs' },
            {
              text: `${selectedJob?.name} - ${selectedJob?.jobNumber}`,
              href: `/jobs/${selectedJob?.id}/summary`,
            },
            { text: 'Meeting Minutes' },
          ],
        }}
        helpText="Manage meeting minutes and track issues for this job"
        helpTitle="Meeting Minutes"
      />

      <Group justify="flex-end" mb="md">
        <CreateButton
          onClick={() => navigate(`/jobs/${selectedJob.id}/meetings/create`)}
        >
          Create Meeting
        </CreateButton>
      </Group>

      <Tabs defaultValue="meetings" mt="md">
        <Tabs.List>
          <Tabs.Tab value="meetings">Meeting Minutes</Tabs.Tab>
          <Tabs.Tab value="issues">Issues</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="meetings">
          <MeetingTable
            meetings={meetings}
            isLoading={loading}
            onMeetingClicked={onMeetingClicked}
            selectedMeetingId={null}
          />
        </Tabs.Panel>

        <Tabs.Panel value="issues">
          <IssuesTable jobId={selectedJob.id} />
        </Tabs.Panel>
      </Tabs>
    </>
  );
};
